/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useMemo } from "react";
// import PhoneInput from "react-phone-input-2";
import { useDispatch, useSelector } from "react-redux";

import { startLoading, stopLoading, setErrorMessage } from "../../../store/ui";
import {
  setOrder,
  resetOrder,
  // parseOrder,
  // parseDateTime,
} from "../../../store/order";

import apiService from "../../../api/api.service";
import {
  tracking_number,
  getUrlParameter,
  order_id,
} from "../../../config/config";
import { validateEmail, validateEmpty } from "../../../utils/validate";
import { parseOrderByCharacter } from "../../../utils/helper";
import { replaceHref } from "../../../utils/replaceHref";
import "react-phone-input-2/lib/style.css";
// import axios from "axios";

const TrackingForm = ({ shop }) => {
  const dispatch = useDispatch();
  const { tracking_form: i18n } = useSelector((state) => state.i18n);
  const {
    trackingForm: settings,
    additional,
    mappingCourier,
    isEnabledEmail,
    isEnabledOrderId,
    isEnabledPhoneNumber,
    isEnabledTrackingNumber,
  } = useSelector((state) => state.settings);
  const [orderName, setOrderName] = useState("");
  const [orderId, setOrderId] = useState(order_id);
  const [email, setEmail] = useState("");
  const [trackingNumber, setTrackingNumber] = useState(tracking_number);
  const [phone, setPhone] = useState("");
  const [invalidMessage, setInvalidMessage] = useState({});
  useEffect(() => {
    if (!tracking_number) {
      setTrackingNumber(getUrlParameter("tracking_number"));
      // setOrderName;
    }
    if (!order_id) {
      setOrderId(getUrlParameter("order_id"));
    }
  }, [tracking_number, order_id]);
  const validForm = () => {
    setInvalidMessage({});
    let isValid = true;
    if (settings.requirePhoneNumber && !validateEmpty(phone)) {
      setInvalidMessage((msg) => ({
        ...msg,
        phoneNumber: i18n.empty_phone_number,
      }));
      isValid = false;
    }

    if (settings.requireOrderId && !validateEmpty(orderName)) {
      setInvalidMessage((msg) => ({
        ...msg,
        orderName: i18n.empty_order_name,
      }));
      isValid = false;
    }

    if (settings.requireEmail && !validateEmpty(email)) {
      setInvalidMessage((msg) => ({
        ...msg,
        email: i18n.empty_email,
      }));
      isValid = false;
    } else if (validateEmpty(email) && !validateEmail(email)) {
      setInvalidMessage((msg) => ({
        ...msg,
        email: i18n.invalid_email,
      }));
      isValid = false;
    }

    if (settings.requireTrackingNumber && !validateEmpty(trackingNumber)) {
      setInvalidMessage((msg) => ({
        ...msg,
        trackingNumber: i18n.empty_tracking_number,
      }));
      isValid = false;
    }

    return isValid;
  };

  const handleTracking = async ({ event, type }) => {
    replaceHref(trackingNumber);
    event?.preventDefault();
    if (!validForm()) return;

    dispatch(startLoading());
    dispatch(setErrorMessage(""));
    dispatch(resetOrder());

    try {
      let endpoint;
      let req = { shop };

      switch (type) {
        case "email":
          endpoint = "submit_track_email";
          req.email = email;
          break;
        case "phone":
          endpoint = "submit_track_phone_number";
          req.phone_number = phone?.replace(/\s/g, "");
          break;
        case "tracking":
          endpoint = "submit_track_tracking_number";
          const trackingSubmit = trackingNumber
            ? trackingNumber?.includes("/")
              ? trackingNumber.replace("/", "")
              : trackingNumber
            : trackingNumber;
          req.tracking_number = trackingSubmit;
          break;
        case "order_id":
          endpoint = "submit_track_order_id";
          req.order_id = orderId;
          req.email = email;
          break;
        default:
          endpoint = "submit_track_order_number";
          req.order = orderName;
          req.email = email;
      }

      const response = await apiService.post(endpoint, req);

      switch (response?.data?.state) {
        case 2:
          dispatch(setErrorMessage(i18n.order_not_found));
          return;
        case 1:
          const dataOrder = response?.data?.order;
          const dataMapping = (item) =>
            parseOrderByCharacter(mappingCourier, item);

          const newDataMapping = dataOrder.map((item) => {
            const { newTrackingDetail, newTrackingCompany } = dataMapping(item);
            return {
              ...item,
              tracking_detail: newTrackingDetail,
              tracking_company: newTrackingCompany,
            };
          });
          dispatch(setOrder(newDataMapping));
          return true;
        default:
          return;
      }
    } catch (err) {
      console.log(err);
    } finally {
      dispatch(stopLoading());
    }
  };

  const handleClickTracking = async (event) => {
    const trackingMethods = [
      {
        enabled: isEnabledTrackingNumber,
        value: trackingNumber,
        type: "tracking",
      },
      {
        enabled: isEnabledOrderId,
        value: orderName,
      },
      {
        enabled: isEnabledEmail,
        value: email,
        type: "email",
      },
      {
        enabled: isEnabledPhoneNumber,
        value: phone,
        type: "phone",
      },
    ];

    for (const method of trackingMethods) {
      if (method.enabled && method.value) {
        const result = await handleTracking({
          event,
          type: method.type,
        });
        if (result) return;
      }
    }
  };

  useEffect(() => {
    const fillTrackingNumberFromParams = async () => {
      let flag = false;
      for (const [key, value] of new URLSearchParams(window.location.search)) {
        switch (key) {
          case "tracking_number":
            setTrackingNumber(value);
            handleTracking({ type: "tracking" });
            return;
          case "order_name":
            setOrderId(value);
            setOrderName(value);
            break;
          case "order_id":
            handleTracking({ type: "order_id" });
            break;
          case "email":
            setEmail(value);
            break;
          default:
            return;
        }
      }
      if (flag) {
        handleTracking();
      }
    };
    // if (blacklist) {
    fillTrackingNumberFromParams();
    // }
  }, []);

  const isDisabledTrackingButton = useMemo(() => {
    let isDisabled = true;
    const listFieldCheck = [
      {
        isEnabled: isEnabledTrackingNumber,
        value: trackingNumber,
      },
      {
        isEnabled: isEnabledOrderId,
        value: orderName,
      },
      {
        isEnabled: isEnabledEmail,
        value: email,
      },
      {
        isEnabled: isEnabledPhoneNumber,
        value: phone,
      },
    ];
    listFieldCheck.forEach((item) => {
      if (item.isEnabled && item.value) {
        isDisabled = false;
      }
    });
    return isDisabled;
  }, [
    isEnabledEmail,
    isEnabledOrderId,
    isEnabledPhoneNumber,
    isEnabledTrackingNumber,
    trackingNumber,
    orderName,
    email,
    phone,
  ]);

  return (
    <div className="container">
      <div className="row">
        <div className="omg-section omg-section--form">
          <h1 className="omg-title">{i18n.title}</h1>
          {additional.textAbove && (
            <div
              className="text-above"
              dangerouslySetInnerHTML={{ __html: additional.textAbove }}
            ></div>
          )}
          <div
            className={
              "omg-layout omg-tracking-form"
              // + (settings.showMethods === "both" ? " omg-layout--half" : "")
            }
          >
            <form id="form-track" className="omg-form">
              {i18n.order_description ? (
                <p style={{ color: "unset" }}>{i18n.order_description}</p>
              ) : null}
              {isEnabledTrackingNumber ? (
                <div className="omg-form-group">
                  <label
                    htmlFor="input-tracking-number"
                    className="omg-form__label"
                  >
                    {i18n.tracking_number}
                  </label>
                  <input
                    type="text"
                    id="input-tracking-number"
                    className="omg-form__control omg-form__control--text"
                    placeholder={i18n.plh_tracking_number}
                    value={trackingNumber}
                    onChange={(event) => setTrackingNumber(event.target.value)}
                  />
                  <span className="omg-form__invalid">
                    {invalidMessage.trackingNumber}
                  </span>
                </div>
              ) : null}
              {isEnabledOrderId && (
                <div className="omg-form-group">
                  <label htmlFor="input-order-name" className="omg-form__label">
                    {i18n.order_id}
                  </label>
                  <input
                    type="text"
                    id="input-order-name"
                    className="omg-form__control omg-form__control--text"
                    placeholder={i18n.plh_order_id}
                    value={orderName}
                    onChange={(event) => setOrderName(event.target.value)}
                  />
                  <span className="omg-form__invalid">
                    {invalidMessage.orderName}
                  </span>
                </div>
              )}
              {isEnabledEmail && (
                <div className="omg-form-group">
                  <label htmlFor="input-email" className="omg-form__label">
                    {i18n.email}
                  </label>
                  <input
                    type="text"
                    id="input-email"
                    className="omg-form__control omg-form__control--text"
                    placeholder={i18n.plh_email}
                    value={email}
                    onChange={(event) => setEmail(event.target.value)}
                  />
                  <span className="omg-form__invalid">
                    {invalidMessage.email}
                  </span>
                </div>
              )}
              {/* {settings.showMethods === "both" && (
                <div className="omg-layout__divider">{i18n.or}</div>
              )} */}
              {isEnabledPhoneNumber ? (
                <div className="omg-form-group">
                  <label
                    htmlFor="input-phone-number"
                    className="omg-form__label"
                  >
                    {i18n.phone}
                  </label>
                  <input
                    id="input-phone-number"
                    // country={country}
                    placeholder={i18n.plh_phone}
                    // enableSearch
                    // disableSearchIcon
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                  />
                  <span className="omg-form__invalid">
                    {invalidMessage.phoneNumber}
                  </span>
                </div>
              ) : null}

              <div className="d-grid gap-2">
                <button
                  className="btn btn-track"
                  type="button"
                  disabled={isDisabledTrackingButton}
                  onClick={handleClickTracking}
                >
                  {i18n.button}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrackingForm;
